import { setPaymentAccessKeyToCookie } from '@source/pages/TransactionPayment/utils';

export const checkAndRedirectPaymentLink = async (
  getPaymentLink: (params: { ticketSlug: string; phone: string }) => Promise<any>,
  ticketSlug: string,
  phone: string,
): Promise<boolean> => {
  try {
    const paymentLinkRes = await getPaymentLink({
      ticketSlug,
      phone,
    });

    if (paymentLinkRes?.data?.success && paymentLinkRes?.data?.data?.payment_link) {
      let transactionSlug;
      try {
        const paymentLinkUrl = new URL(paymentLinkRes.data.data.payment_link);
        transactionSlug = paymentLinkUrl.pathname.split('/').filter(Boolean).pop();
      } catch (error) {
        const pathname = paymentLinkRes.data.data.payment_link;
        transactionSlug = pathname.split('/').filter(Boolean).pop();
      }

      // set payment access key cookie and redirect
      if (transactionSlug) {
        setPaymentAccessKeyToCookie(transactionSlug, phone);

        setTimeout(() => {
          window.location.href = paymentLinkRes.data.data.payment_link;
        }, 100);
        return true;
      }
    }
  } catch (error) {
    // continue with normal flow if payment link fails
    console.error('Payment link check failed:', error);
  }
  return false;
};
